"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _arrayMove = _interopRequireDefault(require("array-move"));

var _ArrayFieldSortableList = _interopRequireDefault(require("./ArrayFieldSortableList"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class ArrayFieldSortable extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      items: []
    });

    _defineProperty(this, "componentDidUpdate", (prevProps, prevState) => {
      if (prevProps.formData !== this.props.formData) {
        this.getItems();
      }
    });

    _defineProperty(this, "getItems", () => {
      const formData = this.props.formData;
      this.setState({
        items: formData
      });
    });

    _defineProperty(this, "onSortStart", ({
      node,
      index,
      collection,
      isKeySorting
    }, event) => {});

    _defineProperty(this, "onSortEnd", ({
      oldIndex,
      newIndex
    }) => {
      const items = this.state.items;
      const formData = (0, _arrayMove.default)(items, oldIndex, newIndex);
      this.props.onChange(formData);
    });
  }

  componentDidMount() {
    this.getItems();
  }

  render() {
    const items = this.state.items;
    return _react.default.createElement(_ArrayFieldSortableList.default, _extends({}, this.props, {
      arrayProps: this.props,
      items: items,
      onSortStart: this.onSortStart,
      onSortEnd: this.onSortEnd,
      helperClass: "sortable-helper",
      hideSortableGhost: true,
      useDragHandle: true
    }));
  }

}

var _default = ArrayFieldSortable;
exports.default = _default;
module.exports = exports.default;